import React from 'react';
import { useRouter } from 'next/router';
import { Link } from '../../../../common/components/link/link';
import { LEFT_NAVIGATION } from '../../configs/left-navigation';

export const LeftNavigation = () => {
	const router = useRouter();
	const activePath = React.useMemo(() => {
		const routeArr = router.pathname.split('/');
		return `/${routeArr[routeArr.length-1]}`;
	}, [router.pathname]);

	return (
		<div className="md:border-r">
			<div className="border-b md:border-b-0 mb-8">
				{LEFT_NAVIGATION.map((item: any) => {
					let linkClasses = 'text-lg cursor-pointer ';
					linkClasses += activePath === item.href
						? 'text-black underline'
						: 'hover:text-black text-gray-700';

					return (
						<div className="mb-4" key={item.title}>
							<Link className={linkClasses} href={`/docs${item.href}`}>
								{item.title}
							</Link>
							<div className="ml-4 text-gray-600">
								{item.anchors.map((anchor: any) => (
									<div key={anchor.title}>
										{anchor.title}
									</div>
								))}
							</div>
						</div>
					)
				})}
			</div>
		</div>
	);
};
